// monarch routes
export enum AppPath {
	Catalog = '/catalog',
	Home = '/',
	NotFound = '/404',
}

// monolith routes
export enum Route {
	AdminGiving = 'company/reports/giving',
	AdminAwards = '/admin/awards',
	AdminAwardsPending = 'admin/awards/pending',
	AdminBilling = '/company/billing',
	AdminBillingActivity = '/company/billing_activity',
	AdminBonusReports = 'company/bonus_reports',
	AdminConfigurations = 'company/settings/configuration/edit',
	AdminChanges = '/admin/security/data_change_logs',
	AdminCompanyChanges = '/admin/security/data_change_logs/company',
	AdminEarnings = '/company/accounts',
	AdminEmptyIntegration = '/company/integrations/user_managements',
	AdminImportedUsers = '/company/imported_users',
	AdminItems = '/company/catalog_items',
	AdminParticipation = '/company/users/participation',
	AdminRecognitionActivity = '/admin/reports/recognition-activity',
	AdminRewards = '/company/rewards?aasm_state=approved&range=all',
	AdminSecurity = '/admin/security/sign_in_logs',
	AdminSettings = '/company/settings/appearance/edit',
	AdminSpend = '/analytics/budget_utilization',
	AdminRedemptions = '/company/rewards/redemptions',
	AdminTotals = '/company/rewards/totals_report',
	AdminUsers = '/company/users',
	SuperAdminManageCompanies = '/super_admin/companies',
	SuperAdminCompanySignUps = '/super_admin/sign_up_activity',
	SuperAdminKyb = '/super_admin/kyb',
	SuperAdminInviteReport = '/super_admin/companies/invite_report',
	SuperAdminCompanyIntegrations = '/super_admin/integrations_dashboards',
	SuperAdminExternalIntegrations = '/super_admin/external_integrations',
	SuperAdminRenewalPriceIncreases = '/super_admin/renewal_price_increases',
	SuperAdminManageUsers = '/super_admin/spoof/new',
	SuperAdminAliasUsers = '/super_admin/alias_users/new',
	SuperAdminPromos = '/super_admin/promos',
	SuperAdminManageRewards = '/super_admin/rewards',
	SuperAdminRewardsHealth = '/super_admin/rewards/health_check',
	SuperAdminTangoOrders = '/super_admin/tangocard_orders',
	SuperAdminManuallyFulfilled = '/super_admin/manually_fulfilled_rewards',
	SuperAdminManageCatalog = '/super_admin/items',
	SuperAdminProviders = '/super_admin/catalog/accounts',
	SuperAdminPublicBrands = '/super_admin/catalog/public_brands',
	SuperAdminOutOfStock = '/super_admin/catalog/out_of_stock',
	SuperAdminLint = '/super_admin/catalog/lint',
	SuperAdminUnimplemented = '/super_admin/catalog/unimplemented_brands',
	SuperAdminPromoted = '/super_admin/catalog/promoted',
	SuperAdminInternals = '/super_admin/control_panel',
	SuperAdminBlocklistedIpAddresses = '/super_admin/blocklisted_ip_addresses',
	SuperAdminBlocklistedEmailDomains = '/super_admin/blocklisted_email_domains',
	SuperAdminPasslistedIpAddresses = '/super_admin/passlisted_ip_addresses',
	SuperAdminScheduledPointEvents = '/super_admin/scheduled_point_events',
	SuperAdminBlocklistedCompanies = '/super_admin/blocklisted_companies',
	SuperAdminMarmonSFTP = '/super_admin/user_management_integrations/marmon_sync',
	SuperAdminRecognitionKVM = '/super_admin/kvms/recognition/giving-rate',
	SuperAdminRedemptionsPerUserKVM = '/super_admin/kvms/rewards/redemptions-per-user',
	SuperAdminOneOnOneKVM = '/super_admin/kvms/one-on-one',
	SuperAdminPulseChecksKVM = '/super_admin/kvms/pulse-checks',
	SuperAdminInsightsKVM = '/super_admin/kvms/insights',
	SuperAdminOneOnOneActivation = '/super_admin/kvms/one-on-one-activation',
	SuperAdminTranscriptMetrics = '/super_admin/kvms/transcript-metrics',
	SuperAdminNotificationMetrics = '/super_admin/kvms/notification-metrics',
	SuperAdminTrialConversion = '/super_admin/kvms/trial-conversion',
	SuperAdminAppPerformance = '/super_admin/kvms/app-performance',
	SuperAdminGoalsAdoption = '/super_admin/kvms/goals-adoption',
	SuperAdminAdviceAdoption = '/super_admin/kvms/advice-adoption',
	SuperAdminOneOnOneAdoption = '/super_admin/kvms/one-on-one-adoption',
	SuperAdminDraftAssistOutcomes = '/super_admin/kvms/bizy/draft-assist-outcomes',
	SuperAdminBizyFeatureRequests = '/super_admin/bizy/feature-requests',
	SuperAdminBizyFeedback = '/super_admin/bizy/feedback',
	SuperAdminBizyConversations = '/super_admin/bizy/conversations',
	SuperAdminConversationSuggestions = '/super_admin/one_on_ones/conversation_suggestions',
	SuperAdminBizyTrends = '/super_admin/bizy/trends',
	SuperAdminBizyOverview = '/super_admin/bizy/overview',
	SuperAdminBizyTopics = '/super_admin/bizy/topics',
	SuperAdminBizyTrainingConversations = '/super_admin/bizy/training_conversations',
	SuperAdminBizyTriggers = '/super_admin/bizy/triggers',
	SuperAdminVideos = '/super_admin/videos',
	SuperAdminEmail = '/super_admin/mailer/index',
	SuperAdminTesting = '/super_admin/testing',
	SuperAdminRewardCertificates = '/super_admin/test/reward_certificates',
	SuperAdminLogoAnalysis = '/super_admin/test/logo_analysis',
	SuperAdminAvatars = '/super_admin/test/avatar',
	SuperAdminIntercom = '/super_admin/intercom_conversations',
	SuperAdminIntegrationsHealth = '/super_admin/hris_health',
	SuperAdminLanguageFeedback = '/super_admin/language_feedbacks',
	SuperAdminBetaFeedback = '/super_admin/beta_feedbacks',
	SuperAdminAnalyticsFeedback = '/super_admin/analytics_chart_feedbacks',
	SuperAdminDonationPayouts = '/super_admin/donation_payouts',
	SuperAdminQualityBotReports = '/super_admin/bonus_quality_bot_reports',
	SuperAdminEvents = '/super_admin/events',
	Integrations = '/company/settings/integrations',
	TechOps = '/tech_ops',
	TechOpsCompany = '/tech_ops/company',
	TechOpsUser = '/tech_ops/user',
}

// external pages
export enum Page {
	DesignSystem = 'https://design.bonus.ly',
	Help = 'https://help.bonus.ly/en/',
	NewFeatures = 'https://help.bonus.ly/en/articles/4076250-product-updates-and-new-features',
}
